import { render, staticRenderFns } from "./NobleList.vue?vue&type=template&id=0036ca19&scoped=true&"
import script from "./NobleList.vue?vue&type=script&lang=js&"
export * from "./NobleList.vue?vue&type=script&lang=js&"
import style0 from "./NobleList.vue?vue&type=style&index=0&id=0036ca19&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0036ca19",
  null
  
)

export default component.exports